import { useContext } from "react";
import LocationContext from "./location-context";

export const useLocation = () => useContext(LocationContext);
